import React from 'react';

export default function StepFooter({ onBack, backDisabled, onSave, saving, onNext, nextLabel, leftHint }) {
  const showSave = !!onSave;
  const showNext = !!onNext;
  return (
    <div style={containerStyle}>
      <div style={leftStyle}>
        <button type="button" onClick={onBack} disabled={backDisabled} style={backDisabled ? backDisabledStyle : backStyle}>
          <Arrow direction="left" />
          Back
        </button>
        {leftHint && <span style={hintStyle}>{leftHint}</span>}
      </div>
      <div style={rightStyle}>
        {showSave && (
          <button type="button" onClick={onSave} disabled={saving} style={saving ? secondaryDisabledStyle : secondaryStyle}>
            {saving ? 'Saving…' : 'Save'}
          </button>
        )}
        {showNext && (
          <button type="button" onClick={onNext} style={accentStyle}>
            {nextLabel || 'Continue'}
            <Arrow direction="right" />
          </button>
        )}
      </div>
    </div>
  );
}

function Arrow({ direction }) {
  const d = direction === 'left' ? 'M19 12H5M11 18l-6-6 6-6' : 'M5 12h14M13 5l7 7-7 7';
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true">
      <path d={d} stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

// Fixed at the bottom of the viewport so wizard navigation is always in
// reach, even when a step body is short. Wizard.jsx adds matching
// padding-bottom to the body so content isn't occluded.
const containerStyle = {
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  background: 'var(--bg)',
  borderTop: '1px solid var(--line)',
  padding: '14px 32px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: '16px',
  zIndex: 40,
};

const leftStyle = { display: 'flex', alignItems: 'center', gap: '10px' };
const rightStyle = { display: 'flex', alignItems: 'center', gap: '10px' };
const hintStyle = { fontSize: '11.5px', color: 'var(--muted)' };

const btnBase = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '8px',
  height: '40px',
  padding: '0 18px',
  borderRadius: '999px',
  fontSize: '13.5px',
  fontWeight: 500,
  cursor: 'pointer',
  fontFamily: 'var(--font)',
};

const backStyle = { ...btnBase, background: 'transparent', border: '1px solid transparent', color: 'var(--ink2)' };
const backDisabledStyle = { ...backStyle, opacity: 0.4, cursor: 'not-allowed' };

const secondaryStyle = { ...btnBase, background: 'var(--surface)', border: '1px solid var(--line)', color: 'var(--ink)' };
const secondaryDisabledStyle = { ...secondaryStyle, opacity: 0.6, cursor: 'not-allowed' };

const accentStyle = { ...btnBase, background: 'var(--accent)', border: '1px solid var(--accent)', color: '#fff' };
